const MANUAL_DERIVATION_STATUS = {
  IN_QUEUE: 'IN_QUEUE',
  IN_ANALYSIS: 'IN_ANALYSIS',
  FINALIZED: 'FINALIZED',
}

export {
  MANUAL_DERIVATION_STATUS,
}
